import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Icon, Input } from 'semantic-ui-react';
import moment from 'moment';

import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';

import { REPORT_ALL_TIME_START_DATE } from '../../../utils/constant';

class DateRangeChart extends PureComponent {
  // getFiscalYearTimestamps() {
  //   const { organization } = this.props;
  //   let startMonthName = 'July',
  //     endMonthName = 'June';
  //   if (
  //     organization &&
  //     organization.settings &&
  //     organization.settings[0].financialYear
  //   ) {
  //     startMonthName = 'July';
  //     endMonthName = 'June';
  //     if (moment().quarter() === 4) {
  //       return {
  //         current: {
  //           start: moment()
  //             .month(startMonthName)
  //             .startOf('month'),
  //           end: moment()
  //             .add(1, 'year')
  //             .month(endMonthName)
  //             .endOf('month')
  //         },
  //         last: {
  //           start: moment()
  //             .subtract(1, 'year')
  //             .month(startMonthName)
  //             .startOf('month'),
  //           end: moment()
  //             .month(endMonthName)
  //             .endOf('month')
  //         }
  //       };
  //     } else {
  //       return {
  //         current: {
  //           start: moment()
  //             .month(startMonthName)
  //             .startOf('month'),
  //           end: moment()
  //             .subtract(1, 'year')
  //             .add(1, 'year')
  //             .month(endMonthName)
  //             .endOf('month')
  //         },
  //         last: {
  //           start: moment()
  //             .subtract(1, 'year')
  //             .month(startMonthName)
  //             .startOf('month'),
  //           end: moment()
  //             .subtract(1, 'year')
  //             .month(endMonthName)
  //             .endOf('month')
  //         }
  //       };
  //     }
  //   } else {
  //     startMonthName = 'January';
  //     endMonthName = 'December';
  //     return {
  //       current: {
  //         start: moment()
  //           .month(startMonthName)
  //           .startOf('month'),
  //         end: moment()
  //           .month(endMonthName)
  //           .endOf('month')
  //       },
  //       last: {
  //         start: moment()
  //           .subtract(1, 'year')
  //           .month(startMonthName)
  //           .startOf('month'),
  //         end: moment()
  //           .subtract(1, 'year')
  //           .month(endMonthName)
  //           .endOf('month')
  //       }
  //     };
  //   }
  // }

  getCalendarYearTimestamps() {
    let startMonthName = 'January',
      endMonthName = 'December';
    return {
      current: {
        start: moment().month(startMonthName).startOf('month'),
        end: moment().month(endMonthName).endOf('month'),
      },
      last: {
        start: moment()
          .subtract(1, 'year')
          .month(startMonthName)
          .startOf('month'),
        end: moment().subtract(1, 'year').month(endMonthName).endOf('month'),
      },
    };
  }

  getFinancialYearTimestamps() {
    let startMonthName = 'July',
      endMonthName = 'June';

    let currentMonthIndex = moment().month();
    // let currentMonthIndex = 7; // used this value to test

    let returnObj;
    if (currentMonthIndex > 6) {
      // 6 == 'June'
      returnObj = {
        current: {
          start: moment().month(startMonthName).startOf('month'),
          end: moment().add(1, 'year').month(endMonthName).endOf('month'),
        },
        last: {
          start: moment()
            .subtract(1, 'year')
            .month(startMonthName)
            .startOf('month'),
          end: moment().month(endMonthName).endOf('month'),
        },
      };
    } else {
      returnObj = {
        current: {
          start: moment()
            .subtract(1, 'year')
            .month(startMonthName)
            .startOf('month'),
          end: moment().month(endMonthName).endOf('month'),
        },
        last: {
          start: moment()
            .subtract(2, 'year')
            .month(startMonthName)
            .startOf('month'),
          end: moment().subtract(1, 'year').month(endMonthName).endOf('month'),
        },
      };
    }

    return returnObj;
  }

  render() {
    const { startDate, endDate, datePicker, t } = this.props;

    return (
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onApply={datePicker}
        ranges={{
          // Today: [
          //   moment().startOf('day'),
          //   moment().endOf('day')
          // ],
          // Yesterday: [
          //   moment().subtract(1, 'days'),
          //   moment().subtract(1, 'days')
          // ],
          [t('date_range.last_7_days')]: [
            moment().subtract(6, 'days'),
            moment(),
          ],
          // 'Last 30 Days': [
          //   moment().subtract(29, 'days'),
          //   moment()
          // ],
          [t('date_range.last_28_days')]: [
            moment().subtract(27, 'days'),
            moment(),
          ],
          [t('date_range.this_month')]: [
            moment().startOf('month'),
            moment().endOf('month'),
          ],
          [t('date_range.last_month')]: [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
          [t('date_range.this_quarter')]: [
            moment().startOf('quarter'),
            moment(),
          ],
          [t('date_range.last_quarter')]: [
            moment().startOf('quarter').subtract(3, 'month'),
            moment().startOf('quarter'),
          ],
          [t('date_range.year_to_date')]: [moment().startOf('year'), moment()],
          // 'Last Year': [moment().subtract(12, 'month'), moment()],
          // 'This Fiscal Year': [
          //   this.getFiscalYearTimestamps().current.start,
          //   this.getFiscalYearTimestamps().current.end
          // ],
          // 'Last Fiscal Year': [
          //   this.getFiscalYearTimestamps().last.start,
          //   this.getFiscalYearTimestamps().last.end
          // ],

          [t('date_range.this_financial_year')]: [
            this.getFinancialYearTimestamps().current.start,
            this.getFinancialYearTimestamps().current.end,
          ],
          [t('date_range.last_financial_year')]: [
            this.getFinancialYearTimestamps().last.start,
            this.getFinancialYearTimestamps().last.end,
          ],
          [t('date_range.this_calendar_year')]: [
            this.getCalendarYearTimestamps().current.start,
            this.getCalendarYearTimestamps().current.end,
          ],
          [t('date_range.last_calendar_year')]: [
            this.getCalendarYearTimestamps().last.start,
            this.getCalendarYearTimestamps().last.end,
          ],

          [t('date_range.since_the_start')]: [
            moment(REPORT_ALL_TIME_START_DATE),
            moment(),
          ],
        }}
      >
        <Input type="text" className="date-picker-btn">
          <span>
            {t('report.from_date_to_date', {
              startDate: startDate.format('DD MMM YYYY'),
              endDate: endDate.format('DD MMM YYYY'),
            })}
          </span>

          <Icon name="calendar alternate" />
        </Input>
      </DateRangePicker>
    );
  }
}

DateRangeChart = withTranslation()(DateRangeChart);

export { DateRangeChart };
